<template>
	<div class="teacher-detail-skeleton" aria-hidden="true">
		<section class="teacher-detail-skeleton__profile">
			<span class="teacher-detail-skeleton__avatar"></span>
			<div class="teacher-detail-skeleton__profile-main">
				<span class="teacher-detail-skeleton__line teacher-detail-skeleton__line--name"></span>
				<div class="teacher-detail-skeleton__tags">
					<span v-for="tag in 3" :key="tag"></span>
				</div>
				<span class="teacher-detail-skeleton__line teacher-detail-skeleton__line--intro"></span>
			</div>
		</section>

		<section class="teacher-detail-skeleton__content">
			<div class="teacher-detail-skeleton__tabs">
				<span v-for="tab in 4" :key="tab"></span>
			</div>
			<div class="teacher-detail-skeleton__grid">
				<div v-for="card in 3" :key="card" class="teacher-detail-skeleton__card">
					<span class="teacher-detail-skeleton__cover"></span>
					<span class="teacher-detail-skeleton__line teacher-detail-skeleton__line--card"></span>
					<span class="teacher-detail-skeleton__line teacher-detail-skeleton__line--short"></span>
				</div>
			</div>
		</section>
	</div>
</template>

<style lang="scss" scoped>
.teacher-detail-skeleton {
	padding-top: 88px;

	&__profile,
	&__content {
		border: 1px solid #eeeeee;
		border-radius: 8px;
		background: #ffffff;
		box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
	}

	&__profile {
		display: flex;
		gap: 28px;
		padding: 40px 48px;
	}

	&__content {
		margin-top: 32px;
		padding: 40px 48px 52px;
	}

	&__avatar,
	&__line,
	&__tags span,
	&__tabs span,
	&__cover {
		display: block;
		background: linear-gradient(90deg, #f1f1f1 25%, #fafafa 40%, #f1f1f1 60%);
		background-size: 300% 100%;
		animation: teacher-detail-shimmer 1.4s ease-in-out infinite;
	}

	&__avatar {
		flex: 0 0 auto;
		width: 150px;
		height: 150px;
		border-radius: 50%;
	}

	&__profile-main {
		flex: 1;
		padding-top: 10px;
	}

	&__line {
		height: 18px;
		border-radius: 5px;

		&--name {
			width: 180px;
			height: 32px;
		}

		&--intro {
			width: min(720px, 85%);
			margin-top: 30px;
		}

		&--card {
			width: 75%;
			margin: 18px 16px 0;
		}

		&--short {
			width: 45%;
			height: 14px;
			margin: 14px 16px 20px;
		}
	}

	&__tags,
	&__tabs {
		display: flex;
		gap: 12px;
	}

	&__tags {
		margin-top: 20px;

		span {
			width: 76px;
			height: 26px;
			border-radius: 6px;
		}
	}

	&__tabs {
		margin-bottom: 32px;

		span {
			width: 120px;
			height: 40px;
			border-radius: 8px;
		}
	}

	&__grid {
		display: grid;
		grid-template-columns: repeat(3, minmax(0, 1fr));
		gap: 20px;
	}

	&__card {
		overflow: hidden;
		border: 1px solid #eeeeee;
		border-radius: 10px;
	}

	&__cover {
		width: 100%;
		aspect-ratio: 16 / 9;
	}
}

@keyframes teacher-detail-shimmer {
	0% {
		background-position: 100% 0;
	}
	100% {
		background-position: 0 0;
	}
}

@media (prefers-reduced-motion: reduce) {
	.teacher-detail-skeleton
		:is(
			.teacher-detail-skeleton__avatar,
			.teacher-detail-skeleton__line,
			.teacher-detail-skeleton__tags span,
			.teacher-detail-skeleton__tabs span,
			.teacher-detail-skeleton__cover
		) {
		animation: none;
	}
}
</style>
